var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center mt-4 mb-4"},[_c('img',{staticClass:"EmptyList__img mt-4",attrs:{"src":require('@/assets/icons/NothingHere.png')}}),_c('h5',{staticClass:"EmptyList__title mt-2"},[_vm._v(" "+_vm._s(_vm.displayText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }